import React, {useEffect, useRef} from "react";
import {Chart, registerables} from "chart.js";
import getChartConfig from "../../AnalyticsHelperLib/ChartHelpers/chartHelperFunctions";
import {useSelector} from "react-redux";
import { useFetchCompanyInfosQuery } from "../../Apis/companyApi";

Chart.register(...registerables);


let chartObj = null;
const ChartSection = ({ analyticsData, analyticsSecondaryData }) => {
    const chartRef = useRef(null);
    const selectedDate = useSelector(state => state.analyticsTimeFrame);
    const selectedType = useSelector(state => state.analyticsType);
    const companyIdList = useSelector(state => state.companyIdList);
    const { data: enterpriseAccounts } = useFetchCompanyInfosQuery();

    useEffect(() => {
        if (!analyticsData || !analyticsSecondaryData || !chartRef.current) {
            return;
        }

        if (chartObj !== null) chartObj.destroy();

        let localConf = null;
        if (companyIdList === null || companyIdList.getCompanyList().length === 0) {
            localConf = getChartConfig(
                analyticsData.getCumulativeData(analyticsSecondaryData),
                selectedType,
                selectedDate
            );
        } else {
            let companyDetailsObj = enterpriseAccounts.getAccountsObj();
            let idList = companyIdList.getCompanyList();
            localConf = getChartConfig(
                analyticsData.getCompanyWiseCumulativeData(idList),
                selectedType,
                selectedDate,
                {companyDetailsObj, idList}
            );
            if (idList.length > 1) localConf.options.animation = false;
        }

        chartObj = new Chart(chartRef.current, localConf);

        return () => {
            if (chartObj !== null) {
                chartObj.destroy();
                chartObj = null;
            }
        };
    }, [analyticsData, analyticsSecondaryData, companyIdList, enterpriseAccounts, selectedDate, selectedType]);

    return (
        <canvas className="analytics-chart mb-4" id={"analytics-chart"} ref={chartRef}></canvas>
    )
}

export default ChartSection;
